import { gql } from '@apollo/client';
import { commentFields } from './commentFields';

const getSortedCommentsForArticle = gql`
  ${commentFields}
  query sortedCommentsForArticle($articleId: ID!, $userId: ID, $parentCommentId: ID) {
    sortedCommentsForArticle(articleId: $articleId, userId: $userId, parentCommentId: $parentCommentId) {
      ...CommentFields
    }
  }
`;
export default getSortedCommentsForArticle;
